import React, { useEffect } from 'react'
import { Col, Container, Row } from 'reactstrap'
import Label from '../../../../components/label/Label'
import TextInput from '../../../../components/input/textinput/TextInput'
import Popup from '../../../../components/popup/Popup'
import styles from "./CalculateTax1099Fee.styles"
import { useDispatch, useSelector } from 'react-redux'
import Loadable from '../../../../components/loadable/Loadable'
import { componentKey } from '../FormListingSlice'
import { FORM_LISTING_LOADING_STATES, FORM_LISTING_MESSAGE_MAP } from '../constants'

const CalculateTax1099Fee = ({ isOpen = false, onCloseCb = () => { }, feeData = {} }) => {

    const { loadingState } = useSelector(state => state[componentKey]);

    const Body = (
        <Loadable
            currentState={loadingState.state}
            messageMap={FORM_LISTING_MESSAGE_MAP}
            loadingStates={[FORM_LISTING_LOADING_STATES.CALCULATE_FEE_AMOUNT_LOADING]}
            isNewLoadable={true}
        >
            <Container>
                <Row style={styles.rowsGap}>
                    <Col md={6}>
                        <Label>Filing Amount</Label>
                        <TextInput placeHolder="Filing Amount" value={feeData?.FilingFee} disabled showDisabledStyles />
                    </Col>

                    <Col md={6}>
                        <Label>Mailing Fee</Label>
                        <TextInput placeHolder='Mailing Fee' value={feeData?.USPSFee} disabled showDisabledStyles />
                    </Col>

                    <Col md={6}>
                        <Label>TIN Match Fee</Label>
                        <TextInput placeHolder='TIN Match Fee' value={feeData?.TINMatchFee} disabled showDisabledStyles />
                    </Col>

                    <Col md={6}>
                        <Label>eDelivery Fee</Label>
                        <TextInput placeHolder='eDelivery Fee' value={feeData?.eDeliveryFee} disabled showDisabledStyles />
                    </Col>

                    <Col md={6}>
                        <Label>State Filing Fee</Label>
                        <TextInput placeHolder='State Filing Fee' value={feeData?.StateFee} disabled showDisabledStyles />
                    </Col>

                    <Col md={6}>
                        <Label>Total Filing Fee</Label>
                        <TextInput placeHolder='Total Filing Fee' value={feeData?.TotalFilingFee} disabled showDisabledStyles />
                    </Col>
                </Row>
            </Container>
        </Loadable>
    )

    return (
        <Popup
            isPopupOpen={isOpen}
            title={"Calculate Tax1099.com Fee"}
            onCloseCb={onCloseCb}
            children={Body}
            childrenStyles={styles.popupBody}
        />
    )
}

export default CalculateTax1099Fee